import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../environment-config';
import { MY_SERVICE_TOKEN } from './localization.tokens';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  private _languageCode: string;

  /**
   * Initiates localization service by loading and preparing all translations
   */
  static init(environment: EnvironmentConfig): Promise<{ [key: string]: string }> {
    return new Promise((resolve) => {
      const languageCode = LocalizationService.getLanguageCode();
      const endpointUrl = `${environment.backendHost}:${environment.backendPort}/localization/${environment.appPackage}/${languageCode}`;

      fetch(endpointUrl)
        .then(res => res.json())
        .then((data) => {
          if (data && data.texts && data.texts.length) {
            resolve(Object.assign({}, ...data.texts.map(it => ({ [it.textId]: it.textValue }))));
          }
        },
          (err) => {
            console.error('Failed to load translations.');
            resolve(null);
          });
    });
  }

  static getLanguageCode(): string {
    return localStorage.getItem('languageCode') || window.navigator['userLanguage'] || window.navigator.language;
  }

  // constructor(@Inject(MY_SERVICE_TOKEN) testi: string) {
  constructor() {
    this.readLanguageCode();
  }

  /**
   * Returns the current selected language code
   *
   * If no has been specified the browser's language code will be used as default
   */
  get languageCode(): string {
    return this._languageCode;
  }

  /**
   * Sets the language code and reloads the app
   */
  set languageCode(value: string) {
    // save in local storage
    localStorage.setItem('languageCode', value);

    // reload app
    location.reload();
  }

  private readLanguageCode() {
    this._languageCode = LocalizationService.getLanguageCode();
  }

}
